import { Map as ImmutableMap, List } from 'immutable';
// @ts-expect-error not migrated
import { formatToReferencesList } from 'reference-resolvers/lib/formatReferences';
export const formatWebInteractives = response => {
  const results = formatToReferencesList({
    getId: webInteractive => webInteractive.properties.hs_object_id.value,
    getLabel: webInteractive => webInteractive.properties.hs_name.value,
    getDescription: webInteractive => webInteractive.properties.hs_container_type.value,
    getArchived: webInteractive => webInteractive.properties.hs_is_archived.value === 'true',
    getDisabled: webInteractive => webInteractive.properties.hs_publish_state.value === 'DRAFT'
  })(List(response.results));
  return ImmutableMap({
    count: results.length,
    offset: response.offset,
    hasMore: response.hasMore,
    results,
    total: response.total
  });
};